$(window).on('load', function(){
    var res = resolutionCheck();
    if(res == 32){
        $('#date-and-time').attr('placeholder', 'Желаемая дата и время');
    }
    else {
        $('#date-and-time').attr('placeholder', 'Желаемая дата и время готовности');
    }
    
});